import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./ClaimAssistant.scss";
import { Button, Link, Menu, MenuItem } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddNewRequest from "../../../../Components/Broker/Endorsment/AddNewRequest/AddNewRequest";
import InitiateAClaim from "../../../../Components/Broker/Claim/InitiateAClaimSp/InitiateAClaim";
import DeletePopup from "../../../../Components/Common/DeletePopup/DeletePopup";
import ClaimPopup from "./ClaimPopup/ClaimPopup";
import ViewDocuments from "../../../../Components/Broker/Claim/ViewDocuments/ViewDocuments";
import EndorsementDetailPopup from "./EndorsementDetailPopup/EndorsementDetailPopup";
import BulkUploadForm from "../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";

const ClaimAssistant = () => {
  const [addNewRequest, setAddNewRequest] = useState(false);
  const [InitiateClaim, setInitiateClaim] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [claimPopup, setClaimPopup] = useState(false);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [uploadFile, setUploadFile] = useState(false);
  const [endorsementDetailPopup, setEndorsementDetailPopup] = useState(false);
  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  const hospitalDetail = [
    {
      heading: "Hospital Name:",
      desc: "Healing Touch Hospital",
    },
    {
      heading: "State:",
      desc: "Haryana",
    },
    {
      heading: "City:",
      desc: "Ambala",
    },
    {
      heading: "Claim Amount:",
      desc: "₹ 50,000",
    },
  ];

  const [requestMenuStatus, setRequestMenuStatus] =
    React.useState<null | HTMLElement>(null);
  const openRequest = Boolean(requestMenuStatus);
  const [userSignOutStatus, setUserSignOutStatus] =
    React.useState<null | HTMLElement>(null);
  const openSignOut = Boolean(userSignOutStatus);

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    attrName: string
  ) => {
    if (attrName == "requestMenuStatus") {
      setRequestMenuStatus(event.currentTarget);
    } else if (attrName == "userSignOutStatus") {
      setUserSignOutStatus(event.currentTarget);
    }
  };

  const handleClose = (attrName: string) => {
    if (attrName == "requestMenuStatus") {
      setRequestMenuStatus(null);
    } else if (attrName == "userSignOutStatus") {
      setUserSignOutStatus(null);
    }
  };

  return (
    <>
      <AddNewRequest
        attrName={setAddNewRequest}
        open_status={addNewRequest}
        value_update={updateMasterState}
      />
      <InitiateAClaim
        attrName={setInitiateClaim}
        open_status={InitiateClaim}
        value_update={updateMasterState}
        client_id_status={true}
      />
      <DeletePopup
        open_status={deleteStatus}
        attrName={setDeleteStatus}
        value_update={updateMasterState}
      />
      <ClaimPopup
        open_status={claimPopup}
        attrName={setClaimPopup}
        value_update={updateMasterState}
      />
      <ViewDocuments
        attrName={setViewDocuments}
        open_status={viewDocuments}
        value_update={updateMasterState}
      />
      <EndorsementDetailPopup
        open_status={endorsementDetailPopup}
        attrName={setEndorsementDetailPopup}
        value_update={updateMasterState}
      />
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <Grid xs className="claimAssistant_wrapper">
        <Grid container spacing={3}>
          <Grid xs={12} className="main_heading mb-10">
            <h5>
              Your <span> Requests</span>
            </h5>
            <p>
              An insurance claim is a formal request to your insurance provider
              for reimbursement against losses covered under your insurance
              policy.
            </p>
          </Grid>
          <Grid xs={12}>
            <div className="raise_request">
              <img src="./images/employee_request_img.svg" />
              <h5>Raise New Request</h5>
              <Link
                className="red_border"
                onClick={() => {
                  setInitiateClaim(true);
                }}
              >
                Claim
              </Link>
              <span>or</span>
              <Link
                className="purple_border"
                onClick={() => {
                  setAddNewRequest(true);
                }}
              >
                Endorsement
              </Link>
            </div>
          </Grid>
          {/* pending request section */}

          {/* <Grid
          xs={12}
          className="pending_request_section"
          sx={{ textAlign: "center" }}
        >
          <img
            src="./images/employer_pendingrequest_img.svg"
            alt=""
            height={250}
          />
          <h6>Don't have any pending request </h6>
        </Grid> */}
          <Grid xs={12} className="mb-6">
            <div className="claim_section red_border">
              <Grid container spacing={3} sx={{ padding: "0" }}>
                <Grid xs={10} sx={{ padding: "0" }}>
                  <div className="claim_innerSection">
                    <Grid container spacing={3}>
                      <Grid xs={6}>
                        <div className="cashlessClaim">
                          <div className="img_section redbg">
                            <img src="./images/employer_heart_img.svg" alt="" />
                          </div>
                          <div className="request_heading">
                            <h5>Cashless Claim Request</h5>
                            <span className="inprogress">In-Progress</span>
                            <Button
                              onClick={() => {
                                setClaimPopup(true);
                              }}
                            >
                              View
                            </Button>
                          </div>
                        </div>
                      </Grid>
                      <Grid xs={6}>
                        <div className="hospitalised_person">
                          <h6>Hopitalised Person</h6>
                          <img
                            src="./images/claim_member_img.svg"
                            alt=""
                            height={50}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="policy_detail pl-6">
                    <h5>
                      Health <span>Insurance</span>
                    </h5>
                    <ul>
                      <li>
                        <span>Policy No.</span>
                        PROH89346794567454
                      </li>
                      <li>
                        <span>Admission Date</span>
                        24/06/2023
                      </li>
                      <li>
                        <span>Reason for Hospitalisation</span>I am going for
                        treatment for a stone located in my lower ureter.
                      </li>
                      <li className="attachicon">
                        <Link
                          className="greenBtn addfile"
                          style={{ paddingTop: "20px" }}
                          onClick={() => {
                            setUploadFile(true);
                          }}
                        ></Link>
                        <Link>
                          <AttachFileIcon
                            onClick={() => {
                              setViewDocuments(true);
                            }}
                          />{" "}
                          3 Docs
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="hospital_detail">
                    <ul>
                      {hospitalDetail.map((data, index) => (
                        <li>
                          <span>{data.heading} </span> {data.desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Grid>
                <Grid
                  xs={2}
                  sx={{ padding: "0", display: "flex", justifyContent: "end" }}
                >
                  <div className="requested_date_section">
                    <h5>
                      <span> Request Date</span> 20/06/2023
                    </h5>
                    <p>11:28 AM</p>
                  </div>
                  <div className="icon_list">
                    <div>
                      <Link
                        className="redBtn delete ml-0"
                        onClick={() => {
                          setDeleteStatus(true);
                        }}
                      ></Link>
                    </div>
                    <div className="mt-11">
                      <Link
                        onClick={(e) => {
                          handleClick(e, "requestMenuStatus");
                        }}
                        aria-controls={openRequest ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openRequest ? "true" : undefined}
                      >
                        <img
                          src="./images/employer_message_icon.svg"
                          alt=""
                          height={30}
                        />
                      </Link>
                      <Menu
                        className="requestList"
                        anchorEl={requestMenuStatus}
                        id="account-menu"
                        open={openRequest}
                        onClose={() => handleClose("requestMenuStatus")}
                        onClick={() => handleClose("requestMenuStatus")}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "#30364d",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        <MenuItem className="list_item">
                          <h6>20/06/2023</h6>
                          <p>We have received your claim request.</p>
                        </MenuItem>
                        <MenuItem className="list_item">
                          <h6>22/06/2023</h6>
                          <p>We have forwarded your request to insurer.</p>
                        </MenuItem>
                        <MenuItem className="list_item">
                          <h6>25/06/2023</h6>
                          <p>Insurer has accepted your request.</p>
                        </MenuItem>
                        <MenuItem className="list_item">
                          <h6>30/06/2023</h6>
                          <p>Your request has been approved.</p>
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid xs={12}>
            <div className="claim_section blue_border">
              <Grid container spacing={3} sx={{ padding: "0" }}>
                <Grid xs={10} sx={{ padding: "0" }}>
                  <div className="claim_innerSection">
                    <Grid container spacing={3}>
                      <Grid xs={6}>
                        <div className="cashlessClaim">
                          <div className="img_section bluebg">
                            <img src="./images/employer_term_img.svg" alt="" />
                          </div>
                          <div className="request_heading">
                            <h5>Endorsement Request</h5>
                            <span className="accepted">Accepted</span>
                            <Button
                              onClick={() => {
                                setEndorsementDetailPopup(true);
                              }}
                            >
                              View
                            </Button>
                          </div>
                        </div>
                      </Grid>
                      <Grid xs={6}>
                        <div className="hospitalised_person">
                          <h6>Member</h6>
                          <img
                            src="./images/claim_member_img.svg"
                            alt=""
                            height={50}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="policy_detail pl-6">
                    <h5>
                      Term <span>Insurance</span>
                    </h5>
                    <ul>
                      <li>
                        <span>Policy No.</span>
                        PROH89346794567454
                      </li>
                      <li>
                        <span>Old Value: Female</span>
                        New Value: Male
                      </li>
                      <li>
                        <span>Old Value: 01/01/1986</span>New Value: 01/01/1998
                      </li>
                      <li className="attachicon">
                        <Link
                          className="greenBtn addfile"
                          style={{ paddingTop: "20px" }}
                          onClick={() => {
                            setUploadFile(true);
                          }}
                        ></Link>
                        <Link>
                          <AttachFileIcon
                            onClick={() => {
                              setViewDocuments(true);
                            }}
                          />{" "}
                          3 Docs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid
                  xs={2}
                  sx={{ padding: "0", display: "flex", justifyContent: "end" }}
                >
                  <div className="requested_date_section">
                    <h5>
                      <span> Request Date</span> 20/06/2023
                    </h5>
                    <p>11:28 AM</p>
                  </div>
                  <div className="icon_list">
                    <div>
                      <Link
                        className="redBtn delete ml-0"
                        onClick={() => {
                          setDeleteStatus(true);
                        }}
                      ></Link>
                    </div>
                    <div className="mt-11">
                      <Link>
                        <img
                          src="./images/employer_message_icon.svg"
                          alt=""
                          height={30}
                        />
                      </Link>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ClaimAssistant;
